module.exports = __webpack_public_path__ + "img/modifiers_icon.4898cdce.svg";